import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import HeaderTabs from 'profile/components/header_tabs';

const mapStateToProps = ({ user, profile }, { router }) => {
  return {
    profile: profile.view.data || {},
    user: user.profile_data
  };
}

export default withRouter(connect(mapStateToProps)(HeaderTabs));
